import {formatISO,parseISO, format, isMatch} from "date-fns";
import JavascriptHelpers from "../../../../components/lib/Javascript/JavascriptHelpers";
import CardUtils from "../../../Observation/Components/Models/CardUtils";
import LocalStorageService from "../../../../services/LocalStorageService";
import CoreService from "../../../../services/CoreService";
import ConfigService from "../../../../services/ConfigService";

import ObservatGenericReportSchema from "../Data/ObservationGenericReport.json";



function getLabelMapColor(label, colorMap)
{
  var labelColor = colorMap.find((c) => c.name === label);
  var result = (labelColor) ? labelColor.id: getRandomColor();
  return re
  sult; 
}




export default class ObservationGenericReportManager 
{


    static async toReportData(reportName, observations, colorMap, gcid)
    {
        var localStorageService = new LocalStorageService();
        var configService = new ConfigService();
    
        var observation = observations[0];
        var schema = localStorageService.getSchema(observation.data.schema.id);
        var reportSchema = ObservatGenericReportSchema;

        var reportObservation = ObservationGenericReportManager.toReportObservation(observation, schema, reportSchema);

        observation = ObservationGenericReportManager.transformGradeDisplay(observation);
        observation = ObservationGenericReportManager.transformCategorySummaryDisplay(observation);
        observation = ObservationGenericReportManager.transformDateDisplay(observation);
        observation = ObservationGenericReportManager.createCategorySummaryDisplay(observation, schema, reportSchema);
        observation = ObservationGenericReportManager.addCustomFields(reportName, observation, schema);
        var result = {gcid: gcid, observation: observation, reportObservation: reportObservation, schema: schema};
        return result;
    }


    static transformDateDisplay(observation)
    {
        var inspectionDt = observation.data.UnderInspection.InspectionDate;
        if (!isMatch(inspectionDt.toString(), "MM/dd/yyyy"))
        {
            observation.data.UnderInspection.InspectionDate = format(parseISO(observation.data.UnderInspection.InspectionDate), "MM/dd/yyyy");
        }
        return observation;
    }

    static transformCategorySummaryDisplay(observation)
    {
        observation.score.Score.GlobalDefects.ByCategory.forEach((cat) =>
        {
            cat.rawPct = parseFloat(cat.rawPct.toFixed(1));
            cat.displayPct =  ((cat.weightedPct<1) && (cat.weightedPct>0)) ? "<1" : JavascriptHelpers.roundHalfDown(cat.weightedPct).toFixed(0);
                
            cat.weightedPct = parseFloat(cat.weightedPct.toFixed(1));


        });
        return observation;
    }


    static transformGradeDisplay(observation)
    {
        observation.score.Score.Gradient.forEach((grade) => {
            if (grade.rules)
            {
                grade.rules.forEach((rule) => {
                    if (rule.totalDefects)
                    {
                        rule.totalDefects = parseFloat(rule.totalDefects.toFixed(1));
                    }
                    if (rule.weightedScore)
                    {    
                        rule.weightedScore = parseFloat(rule.weightedScore.toFixed(1));
                    }
                    if (rule.rawScore)
                    {    
                        rule.rawScore = parseFloat(rule.rawScore.toFixed(1));
                    }
                    rule.displayPct =  ((rule.pct<1) && (rule.pct>0)) ? "<1" : JavascriptHelpers.roundHalfDown(rule.pct).toFixed(0);
                

                });
            }
        });
        return observation;
    }


    static toReportObservation(observation, schema, reportSchema)
    {
        var result = {};
        result.header = {};
        var configService = new ConfigService();
        result.header.customerLogoSrc = configService.getCustomerLogoImagePath(observation.data.schema.gcid);
        result.header.title = reportSchema.header.title;
        result.header.runDate = {label: "Run Date", value: format(new Date(), reportSchema.header.runAtFormat)};

        result.summary = {};
        var reportSummaryTitleSuffix = (reportSchema.summary.showGradeInTitle) ? ": " + observation.score.Score.Grade.Weighted : "";
        result.summary.title = reportSchema.summary.title + reportSummaryTitleSuffix;
            
        result.summary.props = [];
        reportSchema.summary.props.forEach((prop) => {
            var val = JavascriptHelpers.getPathValue(observation, prop.propPath);
            if ((!val) && (!reportSchema.summary.showEmptyProps)) return;
            var lbl = prop.label;
            if (!lbl)
            {
                // get the label from the schema card title
                var card = CardUtils.findCard(schema, prop.propPath);
                lbl = (card.label) ? card.label :
                    (card.title) ? card.title : card.id;
            }
            if (prop.type)
            {
                if (prop.type === "date")
                {
                    val = format(parseISO(val), prop.format);
                }
            }
            result.summary.props.push({label: lbl, value: val});
        });

        result.underInspection = {};
        var underInspectionTitleSuffix =  (reportSchema.underInspection.showSchemaInTitle) ? ": " + observation.data.schema.name : "";
        result.underInspection.title = reportSchema.underInspection.title + underInspectionTitleSuffix;
        result.underInspection.props = [];
        if (reportSchema.underInspection.useAllProps)
        {
            var oui = schema.categories.find((cat) => cat.id === "oui");
            var cards = CardUtils.findAllCardsInCategory(schema, oui);
            cards.forEach((card) => {
                var val = observation.data.Raw[card.id];
                if ((!val) && (!reportSchema.underInspection.showEmptyProps)) return;
                var lbl = (card.label) ? card.label :
                    (card.title) ? card.title : card.id;
                result.underInspection.props.push({label: lbl, value: val});
            })
        }
        else {
            reportSchema.underInspection.props.forEach((prop) => {
                var val = JavascriptHelpers.getPathValue(observation, prop.propPath);
                if ((!val) && (!reportSchema.underInspection.showEmptyProps)) return;
                var lbl = prop.label;
                if (!lbl)
                {
                    // get the label from the schema card title
                    var card = CardUtils.findCard(schema, prop.propPath);
                    lbl = (card.label) ? card.label :
                        (card.title) ? card.title : card.id;
                }
                result.underInspection.props.push({label: lbl, value: val});
            });
        }

        var totalDefects = 0;
        result.defects = {};
        result.defects.title = reportSchema.defects.title;
        var schemaDefects = schema.categories.find(cat => cat.id === "defects");
        var schemaDefectGroups = schemaDefects.groups;
        result.defects.groups = [];
        schemaDefectGroups.forEach((group) => {
            // skip non-defect categories within defects
            if ((group.groupTitle.toLowerCase() === "count") || (group.groupTitle.toLowerCase() === "weight")) return;
            var groupProps = [];
            group.cards.forEach((card) => {
                val = observation.data.Raw[card.id];
                if ((!val) && (!reportSchema.defects.showNullDefects)) return;
                if (val) totalDefects = totalDefects + parseInt(val);
                val = (val) ? val : "";
                var lbl = (card.label) ? card.label :
                     (card.title) ? card.title : card.id;
                groupProps.push({label: lbl, value: val});
            });
            if (groupProps.length > 1)
            {
                result.defects.groups.push({label: group.groupTitle, defects: groupProps})
            }
        });
        if ((reportSchema.defects.totals) && (reportSchema.defects.totals.showTotals))
        {
            result.defects.totals = {};
            result.defects.totals.title = reportSchema.defects.totals.title;
            result.defects.totals.props = [];
            result.defects.totals.props.push({label: reportSchema.defects.totals.totalInspected.label, value: JavascriptHelpers.getPathValue(observation, reportSchema.defects.totals.totalInspected.propPath)});
            result.defects.totals.props.push({label: reportSchema.defects.totals.totalDefects.label, value: totalDefects});
        }


        result.gradingScoring = {};
        result.gradingScoring.title = reportSchema.gradingScoring.title;
        result.gradingScoring.grades = [];
        var allGrades = observation.score.Score.Gradient;
        for (var i=0; i<allGrades.length; i++)
        {
            var grade = allGrades[i];
            if (i === allGrades.length-1)
            {
                // last grade 
                grade.passed = true;

            }
            if (!grade.passed)
            {
                if (reportSchema.gradingScoring.showOnlySelectedGrade) return;
            }
            var gradeResult = {label: grade.grade, passed: grade.passed,
                result: (grade.passed) ? reportSchema.gradingScoring.passLabel : reportSchema.gradingScoring.failLabel, 
                rules: []
            };
            if (!grade.rules)
            {
                // the last grade doesn't have any rules! 
                grade.rules = [];
            }
            grade.rules.forEach((rule) => {
                var rulePct =  rule.weightedScore; // TBD - here use display information for rounding/digits
                var rulePctDisplay = "";
                if (reportSchema.gradingScoring.display?.rounding?.roundingType)
                {
                    switch(reportSchema.gradingScoring.display?.rounding?.roundingType)
                    {
                        case "toFixed":
                            rulePctDisplay = rulePct.toFixed(reportSchema.gradingScoring.display.rounding.fixedDigits);
                            break;
                        // note that round will round .5 UP. See roundhalfdown for rounding DOWN. 
                        case "round":
                            rulePctDisplay = Math.round(rulePct).toFixed(0);
                            break;
                        case "roundhalfdown":
                            rulePctDisplay = JavascriptHelpers.roundHalfDown(rulePct).toFixed(0);
                            break;
                        case "ceil":
                            rulePctDisplay = Math.ceil(rulePct);
                            break;
                        case "floor":
                            rulePctDisplay = Math.floor(rulePct);
                            break;
                    }
                }
                var ruleResult = {label: rule.title, description: rule.description, totalDefects: rule.totalDefects, pctDefects: rulePctDisplay, result: (rule.passed) ? reportSchema.gradingScoring.passLabel: reportSchema.gradingScoring.failLabel};
                gradeResult.rules.push(ruleResult);
            });
            result.gradingScoring.grades.push(gradeResult);
        };

        if (reportSchema.other.display)
        {
            result.other = {};
            result.other.title = reportSchema.other.title;
            reportSchema.other.props.forEach((prop) => {
                var val = JavascriptHelpers.getPathValue(observation, prop.propPath);
                if ((!val) && (!reportSchema.underInspection.showEmptyProps)) return;
                var lbl = prop.label;
                if (!lbl)
                {
                    // get the label from the schema card title
                    var card = CardUtils.findCard(schema, prop.propPath);
                    lbl = (card.label) ? card.label :
                        (card.title) ? card.title : card.id;
                }
                result.other.props.push({label: lbl, value: val});
            });
        }

        if (reportSchema.environment.display)
        {
            result.environment = {};
            result.environment.title = reportSchema.environment.title;
            result.environment.props = [];
            if (reportSchema.environment.useAllProps)
            {
                var envData = observation.data.Environment;
                for (const [key, value] of Object.entries(envData)) 
                {
                    if (value && key !== "Comments") 
                    {
                        result.environment.props.push({label: key, value: value});
                    }
                }
            }  
            else 
            {
                reportSchema.environment.props.forEach((prop) => {
                    var val = JavascriptHelpers.getPathValue(observation, prop.propPath);
                    if ((!val) && (!reportSchema.environment.showEmptyProps)) return;
                    var lbl = prop.label;
                    if (!lbl)
                    {
                        // get the label from the schema card title
                        var card = CardUtils.findCard(schema, prop.propPath);
                        lbl = (card.label) ? card.label :
                            (card.title) ? card.title : card.id;
                    }
                    result.environment.props.push({label: lbl, value: val});
                });
            }

        }

        if (reportSchema.comments.display)
        {
            result.commentsNotes = {};
            result.commentsNotes.title = reportSchema.comments.title;
            var val = JavascriptHelpers.getPathValue(observation, reportSchema.comments.propPath);
            result.commentsNotes.comment = (val) ? val : reportSchema.comments.textIfEmpty;
        }

        if (reportSchema.userImages.display)
        {
            result.userImages = {};
            result.userImages.title = reportSchema.userImages.title;
            result.userImages.hasImages =  (!observation.data.Raw.userimages);
            result.userImages.noImagesText = reportSchema.userImages.textIfEmpty;
            result.userImages.images = [];
            observation.data.Raw.userimages.map(el => 
            {
                var tagList = (el.tags) ? el.tags.map((tag) => {
                    return tag.label;
                }).join(', ')
                : ""

                var imgExtension;
                if (el.ext === "png") 
                {
                    imgExtension = ".png"
                } else if (el.ext === "jpeg") 
                {
                    imgExtension = ".jpeg"
                }
                result.userImages.images.push({id: el.id, 
                    label: el.descript, 
                    src: this.configService.getGcidUserImageBasePath(observation.data.Raw.gcid) + el.id + imgExtension,
                    //src: this.configService.getObsImageHostAddr(this.gcid, "user") + el.id + imgExtension,
                    alt: reportSchema.userImages.altText
                }); 
            })




        }

        if (reportSchema.userDocuments.display)
        {
            result.userDocuments = {};
            result.userDocuments.title = reportSchema.userDocuents.title;
            result.userDocuments.hasDocuments =  (!observation.data.Raw.userDocuments);
            result.userDocuments.noDocumentsText = reportSchema.userDocuments.textIfEmpty;
            result.userDocuments.documents = [];
            observation.data.Raw.userDocuments.map(el => 
            {
                var tagList = (el.tags) ? el.tags.map((tag) => {
                    return tag.label;
                }).join(', ')
                : ""
                result.userDocuments.documents.push({id: el.id, 
                    label: el.descript, 
                    src: this.configService.getDocImageHostAddr(this.gcid, "user") + el.id + "pdf",
                    alt: reportSchema.userDocuments.altText
                }); 
            })
        }

       
        //result.header.observationDate = {label: reportSchema.title.observationDate.label, value: format(parseISO(observation.data.UnderInspection.ObservationDate), reportSchema.title.observationDate.format)};

        return result;

    }

    static createCategorySummaryDisplay(observation, schema, reportSchema)
    {
        observation.categorySummary = [];
        // we want to include ALL categories, even if they have no subtotals
        // use the schema scoring 
        schema.scoring.globalGroupMultipliers.forEach((cat) => 
        {
            var category = {title: (cat.label) ? cat.label : cat.title};
            // if it had no defects, then it won't show up. 
            var obsCategory = observation.score.Score.GlobalDefects.ByCategory.find((obsCat) => obsCat.category === CardUtils.titleToId(cat.title));
            if (obsCategory)
            {
                category.value = obsCategory.value;
                category.weightedMultiplier = obsCategory.weightedMultiplier;
                category.rawPct = parseFloat(obsCategory.rawPct);
                category.weightedPct = parseFloat(obsCategory.weightedPct);
                category.displayPct =  ((obsCategory.weightedPct.pct<1) && (obsCategory.weightedPct.pct>0)) ? "<1" : JavascriptHelpers.roundHalfDown(obsCategory.weightedPct).toFixed(0);
     
            }
            else
            {
                category.value = 0;
                category.weightedMultiplier = 0;
                category.rawPct = 0;
                category.weightedPct = 0;
                category.displayPct =  0;
  
            }
            observation.categorySummary.push(category);
        });
        var categoryTotal = observation.categorySummary.reduce(function (acc, obj) { return acc + obj.weightedPct; }, 0);
        var categoryDisplayPct = ((categoryTotal<1) && (categoryTotal>0)) ? "<1" : JavascriptHelpers.roundHalfDown(categoryTotal).toFixed(0);
        observation.categoryTotal = {weightedPct: categoryTotal, displayPct: categoryDisplayPct};
        return observation;
    }


    static addCustomFields(reportName, observation, schema)
    {
        observation.customFields = [];
        var report = schema.reports.find((r) => r.id === reportName);
        if (!report) return observation;

        var customFields = report.customFields;
        if (!customFields) return observation;
            
        observation.data.customFields = customFields.map((cf) =>{
            return ObservationGenericReportManager.toCustomField(cf, observation);
        });
        
        observation.customFields = customFields;
        return observation;
    }


    static toCustomField(customField, observation)
    {
        var rawValue = observation.data.Raw[customField.id];
        return {"label": customField.label, "value": rawValue};

    }








    static toUniqueString(observations, prop)
    {
        var all = observations.map((observation) => {return (observation.data.Raw[prop]) ? observation.data.Raw[prop] : ""});
        var result = [...new Set(all)];
        return result.join(" ");
    }

    static toPalletTagString(palletTagValue)
    {
        if (!palletTagValue) return "";
        return (Array.isArray(palletTagValue)) ? palletTagValue.map((pt) => {return pt.famouspallet}).join(" / ") : palletTagValue;
    }

    static toRange(observations, propertyName, propertyPath)
    {
        var rangeValues = observations.map((observation) => {return observation.data[propertyPath][propertyName]});
        var max = Math.max(...rangeValues);
        var min = Math.min(...rangeValues);
        //return {min: min, max: max};
        var maxDisplay = (Number.isNaN(max)) ? "" : max;
        var minDisplay = (Number.isNaN(min)) ? "" : min;
        var hasDisplay = (!Number.isNaN(max) || (!Number.isNaN(min)));
        return (hasDisplay) ? minDisplay + "-" + maxDisplay : "not available";
    }


    static hasAny(observations, prop)
    {
        var result = observations.some((observation) => {return (observation.data.Raw[prop])});
        return (result) ? "Yes" : "No";
    }


















}


